'use strict';
const mmWidgets = require('../widgets/mm-widgets');

mmWidgets.fn.subteamAddableMemberListWidget = function (subteamModel, container) {
	if (!subteamModel || !container) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this,
			addableMemberListTemplate = element.find('[data-mm-role~="addable-member-list-template"]').detach();

		addableMemberListTemplate.attr('data-mm-role', false);
		subteamModel.addEventListener('showAddableEmails', (subteam, addableEmails) => {
			element.empty();
			addableEmails.sort().forEach(memberEmail => {
				const memberWidget = addableMemberListTemplate.clone();
				memberWidget.appendTo(element);
				memberWidget.find('[data-mm-role~="member-email"]').text(memberEmail);
				memberWidget.find(`[data-mm-sub-team-to-role][data-mm-sub-team-role-required~="${subteam.role}"]`)
				.removeClass('hidden')
				.click(function (e) {
					container.showProgressMessage('Adding email to team, please wait...');
					const role = e.currentTarget.getAttribute('data-mm-sub-team-to-role');
					subteamModel.addEmailToTeam(subteam, memberEmail, role, addableEmails)
					.catch((reason) => {
						container.showError(reason);
					});
				});
			});
		});
	});
};
